module.exports = __webpack_public_path__ + "img/infield-pavillion.aacc3ad7.svg";